var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Typography } from "../Typography";
import { FiPlus, FiMinus } from "react-icons/fi";
import { Wrapper, Header, Question, ExpandIcon, Answer } from "./atoms";

var Type = function Type(props) {
  return React.createElement(
    Typography,
    _extends({ $as: "p", size: [1, 1, 1], color: "textMedium" }, props),
    props.children
  );
};

var CollapsableArticle = function CollapsableArticle(_ref) {
  var question = _ref.question,
      answer = _ref.answer,
      restProps = _objectWithoutProperties(_ref, ["question", "answer"]);

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  // TODO: when clicked: link to #anchor


  return React.createElement(
    Wrapper,
    _extends({
      className: open && "open",
      itemScope: true,
      itemProp: "mainEntity",
      itemType: "https://schema.org/Question"
    }, restProps),
    React.createElement(
      Header,
      { onClick: function onClick() {
          return setOpen(!open);
        } },
      React.createElement(
        Question,
        null,
        React.createElement(
          Type,
          { bold: true, itemProp: "name" },
          question
        )
      ),
      React.createElement(
        ExpandIcon,
        null,
        open ? React.createElement(FiMinus, null) : React.createElement(FiPlus, null)
      )
    ),
    React.createElement(
      Answer,
      {
        className: open && "open",
        itemScope: true,
        itemProp: "acceptedAnswer",
        itemType: "https://schema.org/Answer"
      },
      React.createElement(
        Type,
        { itemProp: "text" },
        answer
      )
    )
  );
};

export { CollapsableArticle };
CollapsableArticle.propTypes = process.env.NODE_ENV !== "production" ? {
  question: PropTypes.node.isRequired,
  answer: PropTypes.node.isRequired
} : {};

CollapsableArticle.defaultProps = {
  question: "Lorem ipsum?",
  answer: "Yes! Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
};